import c from 'classnames';
import { ReactNode } from 'react';
import {
  HeaderMenuListItem,
  HeaderMenuListItemProps,
} from '../Navigation/common/HeaderMenuListItem';
import { UserMenuSectionDisplay } from './types';

type UserMenuSectionProps = {
  display?: UserMenuSectionDisplay;
  items: HeaderMenuListItemProps[];
  /** Rendered before `items[extraItemIndex]`, or last when out of range. */
  extraItem?: ReactNode;
  extraItemIndex?: number;
};

const USER_MENU_ITEM_TEST_ID = 'user-menu-item';
const EXTRA_ITEM_KEY = 'user-menu-extra-item';
const EXTRA_ITEM = Symbol(EXTRA_ITEM_KEY);

export const UserMenuSection = ({
  display = 'All',
  items,
  extraItem,
  extraItemIndex = items.length,
}: UserMenuSectionProps) => {
  const entries: Array<HeaderMenuListItemProps | typeof EXTRA_ITEM> = extraItem
    ? [
        ...items.slice(0, extraItemIndex),
        EXTRA_ITEM,
        ...items.slice(extraItemIndex),
      ]
    : items;

  return entries.map((entry, index) => {
    const isExtraItem = entry === EXTRA_ITEM;

    if (!isExtraItem && !entry.href && !entry.handleSelect) {
      return null;
    }

    // The extra item shows on every breakpoint, whatever the section display.
    const listItemClassNames = c('pb-4', {
      'pt-5': index === 0,
      'border-b border-grey-800 pb-5 last-of-type:border-0':
        index === entries.length - 1,
      'lg:hidden': display === 'Mobile' && !isExtraItem,
      'hidden lg:block': display === 'Desktop' && !isExtraItem,
    });

    return (
      <li
        key={isExtraItem ? EXTRA_ITEM_KEY : entry.value}
        className={listItemClassNames}
      >
        {isExtraItem ? (
          extraItem
        ) : (
          <HeaderMenuListItem
            {...entry}
            testId={USER_MENU_ITEM_TEST_ID}
            classNames="lg:pl-4"
          />
        )}
      </li>
    );
  });
};
